import { useNavigationStore } from "~/stores/navigation";

export default defineNuxtRouteMiddleware((to) => {
  const localePath = useLocalePath();
  const navStore = useNavigationStore();

  const result = navStore.matchMenuItemByPath(to.path);
  const hasAccess = !result || result.hasAccess;

  if (!hasAccess) {
    devConsole.warn("Access denied to route", to.path);
    return navigateTo(localePath("/"));
  }

  return true;
});
